// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const LazyImage = require('client-v2/common/components/lazy-image')
const useLineClampFitStyle = require('client-v2/common/hooks/line-clamp')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('ContentAddModalArticlePreview')

function ContentAddModalArticlePreview({
  // Flags
  isArticleFailed,
  isArticleLoading,
  // Values
  article,
  className,
  // Callbacks
  onRetryClick
}) {
  return (
    tag('div', {
      className: classNames(
        className,
        bem.block()
      )
    },
      tag(ContentAddModalArticlePreviewPlaceholder, {
        isArticleFailed,
        isArticleLoading,
        article
      }),
      tag(ContentAddModalArticlePreviewError, {
        isArticleFailed,
        onRetryClick
      }),
      tag(ContentAddModalArticlePreviewContent, {
        article
      })
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const ArticleModelRecord = require('client-v2/common/models/article/record')

  ContentAddModalArticlePreview.propTypes = {
    // Flags
    isArticleLoading: PropTypes.bool,
    isArticleFailed: PropTypes.bool,
    // Values
    article: PropTypes.shape(ArticleModelRecord.propTypes),
    className: PropTypes.string,
    // Callbacks
    onRetryClick: PropTypes.func
  }
}

module.exports = ContentAddModalArticlePreview

function ContentAddModalArticlePreviewPlaceholder({
  isArticleFailed,
  isArticleLoading,
  article
}) {
  if (isArticleFailed || article) {
    return null
  }
  return (
    tag('div', {
      className: bem.element('placeholder', {
        loading: isArticleLoading
      })
    })
  )
}

function ContentAddModalArticlePreviewContent({
  article
}) {
  const titleRef = React.useRef()
  const titleStyle = useLineClampFitStyle({
    disabled: !article,
    domRef: titleRef
  })
  const descriptionRef = React.useRef()
  const descriptionStyle = useLineClampFitStyle({
    disabled: !article,
    domRef: descriptionRef
  })
  if (!article) {
    return null
  }
  return (
    tag('div', {
      className: bem.element('content')
    },
      tag(LazyImage, {
        className: bem.element('image'),
        sources: [ article.md5image, article.image ]
      }),
      tag('div', {
        className: bem.element('details')
      },
        tag('div', {
          className: bem.element('domain')
        },
          article.hostname
        ),
        tag('div', {
          ref: titleRef,
          className: bem.element('title'),
          style: titleStyle
        },
          article.title
        ),
        tag('div', {
          ref: descriptionRef,
          className: bem.element('description'),
          style: descriptionStyle
        },
          article.description
        )
      )
    )
  )
}

function ContentAddModalArticlePreviewError({
  isArticleFailed,
  onRetryClick
}) {
  if (!isArticleFailed) {
    return null
  }
  return (
    tag('div', {
      className: bem.element('error')
    },
      tag('p', {
        className: bem.element('error-heading')
      },
        'Oops.'
      ),
      tag('p', {
        className: bem.element('error-subheading')
      },
        'We couldn’t gather the information from this website.'
      ),
      tag('p', {
        className: bem.element('error-subheading')
      },
        'Please double-check your link or try again later.'
      ),
      tag('div', {
        className: bem.element('error-actions')
      },
        tag(CapsuleButton, {
          className: bem.element('error-button'),
          onClick: onRetryClick
        },
          'Retry'
        ),
        tag(CapsuleButton, {
          className: bem.element('error-button'),
          href: 'mailto:support@mix.com'
        },
          'Contact Support'
        )
      )
    )
  )
}
